import style from './style.module.scss'
import { Text } from '@crossfit/design-system'
import badge1 from '../../images/L1-BADGE.svg'
import badge2 from '../../images/L2-BADGE.svg'
import badge3 from '../../images/L3-BADGE.svg'
import badge4 from '../../images/L4-BADGE.svg'
import CoachAvatar from '../CoachAvatar'
import Toggle, { ToggleValue } from 'components/Admin/Shared/Toggle'
import { AffiliateMemberCertification } from 'types'

type Props = {
  name: string
  role: string
  certifications: AffiliateMemberCertification[]
  userId: number
  toggleValue: ToggleValue
  onToggle?: (ToggleValue) => void
}

export default function Coach({
  name,
  role,
  certifications,
  userId,
  toggleValue,
  onToggle,
}: Props) {
  const certificationLevels = certifications.map((c) => c.level)
  const showL1Badge =
    (certificationLevels.includes('L1') ||
      certificationLevels.includes('OL1')) &&
    !certificationLevels.includes('L2') &&
    !certificationLevels.includes('L3') &&
    !certificationLevels.includes('L4')
  const showL2Badge =
    certificationLevels.includes('L2') &&
    !certificationLevels.includes('L3') &&
    !certificationLevels.includes('L4')
  const showL3adge =
    certificationLevels.includes('L3') && !certificationLevels.includes('L4')
  const showL4Badge = certificationLevels.includes('L4')
  return (
    <>
      <div className={style.left}>
        <div className={style.personal}>
          <div className={style.image}>
            <CoachAvatar id={userId} />
          </div>
          <div className={style.name}>
            <Text size='sm' bold={true} type='body' className={style.nameText}>
              {name}
            </Text>
            <Text type='data' size='sm' className={style.roleText}>
              {role === 'lor' ? 'Owner' : role === 'preferred' ? 'Coach' : role}
            </Text>
          </div>
        </div>
        <div className={style.levelsContainer}>
          <div className={style.levels}>
            {showL1Badge && (
              <div className={style.level}>
                <img src={badge1} alt='Level 1 Badge' />
              </div>
            )}

            {showL2Badge && (
              <div className={style.level}>
                <img src={badge2} />
              </div>
            )}
            {showL3adge && (
              <div className={style.level}>
                <img src={badge3} />
              </div>
            )}
            {showL4Badge && (
              <div className={style.level}>
                <img src={badge4} />
              </div>
            )}
          </div>
          {certifications.length > 4 ? (
            <div className={style.otherCreds}>
              <Text size='xs' type='overline' className={style.otherCredsText}>
                Other Credentials
              </Text>
            </div>
          ) : null}
        </div>
      </div>
      <div className={style.right}>
        <Toggle
          toggleValue={toggleValue}
          onToggle={(newtoggleValue) => {
            onToggle(newtoggleValue)
          }}
        />
      </div>
    </>
  )
}
